import { useContext } from "react";
import { DatabaseSearchContext, Wrapper } from "nystem-components";

const ViewListLifetimeValue = ({ model }) => {
  const { search } = useContext(DatabaseSearchContext);
  const value = search.lifetimeValue;

  return (
    <Wrapper className={model.className}>
      {model.text}{" "}
      {value === undefined
        ? "Beräknar…"
        : `${new Intl.NumberFormat("sv-SE").format(value)} kr`}
    </Wrapper>
  );
};

export default ViewListLifetimeValue;
